document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-section-container video[data-end-percent]').forEach(video => {
    video.addEventListener('loadedmetadata', () => {
      const endTime = video.duration * (video.dataset.endPercent / 100);
      video.addEventListener('timeupdate', () => {
        if (video.currentTime >= endTime) {
          video.loop ? video.currentTime = 0 : video.pause();
        }
      });
    });
  });
});